import { OwnedAssistanceProduct } from '@/interfaces';
import { AssistanceStatus } from '@/constants/portfolio.const';
import { RoadsideProductType } from '../roadside-helpers';

export enum RsaStatusInfoBox {
  None = 'None',
  RenewalPaymentDue = 'RenewalPaymentDueWarningInfoBox',
  PaymentOverdue = 'PaymentOverdueErrorInfoBox',
  CoverExpired = 'CoverExpiredErrorInfoBox',
  PaymentOutstanding = 'PaymentOutstandingErrorInfoBox',
  RenewalUpcoming = 'RenewalUpcomingWarningInfoBox',
  PaymentNotYetReceived = 'PaymentNotYetReceivedErrorInfoBox',
  RenewalDue = 'RenewalDueWarningInfoBox',
  RenewalOverdue = 'RenewalOverdueErrorInfoBox',
}

const isStandardProduct = (policy: OwnedAssistanceProduct): boolean => {
  if (
    policy?.roadsidePolicyType === RoadsideProductType.Standard || // Standard product from Portfolio
    ['ARN', 'ARV', 'AREX'].some((prefix) => policy?.productCode?.toUpperCase().startsWith(prefix)) // Associate, RV, or Excess Product
  ) {
    return true;
  }
  return false;
};

const getRsaStatusInfoBox = (policy: OwnedAssistanceProduct): RsaStatusInfoBox => {
  if (isStandardProduct(policy) || policy?.roadsidePolicyType === RoadsideProductType.Cmo) {
    if (policy.status == AssistanceStatus.Activated) {
      return RsaStatusInfoBox.None;
    } else if ([AssistanceStatus.Lapsed, AssistanceStatus.Expired].includes(policy.status as string)) {
      return RsaStatusInfoBox.CoverExpired;
    } else if (policy.status == AssistanceStatus.PendingPayment) {
      return RsaStatusInfoBox.PaymentOutstanding;
    }
  }

  if (isStandardProduct(policy) && policy.isAutoPayment === false) {
    if (policy.status == AssistanceStatus.RenewalProduced) {
      return RsaStatusInfoBox.RenewalPaymentDue;
    } else if (policy.status == AssistanceStatus.ReminderProduced) {
      return RsaStatusInfoBox.PaymentOverdue;
    }
  } else if (isStandardProduct(policy) && policy.isAutoPayment === true) {
    if (policy.status == AssistanceStatus.RenewalProduced) {
      return RsaStatusInfoBox.RenewalUpcoming;
    } else if (policy.status === AssistanceStatus.ReminderProduced) {
      return RsaStatusInfoBox.PaymentNotYetReceived;
    }
  } else if (policy?.roadsidePolicyType === RoadsideProductType.Cmo) {
    if (policy.status == AssistanceStatus.RenewalProduced) {
      return RsaStatusInfoBox.RenewalDue;
    } else if (policy.status == AssistanceStatus.ReminderProduced) {
      return RsaStatusInfoBox.RenewalOverdue;
    }
  }

  return RsaStatusInfoBox.None;
};

export const RSAStatusInformationBoxRules = {
  getRsaStatusInfoBox,
};
